import { Download, Upload } from 'lucide-react';

import { FeatureId } from '@/react/portainer/feature-flags/enums';

import { BoxSelectorOption } from '@@/BoxSelector';

export function createRestoreOptions(
  isFIPSMode = false
): ReadonlyArray<BoxSelectorOption<string>> {
  return [
    {
      id: 'restore_file',
      value: 'file',
      icon: Upload,
      iconType: 'badge',
      label: 'Upload backup file',
    },
    {
      id: 'restore_s3',
      value: 's3',
      icon: Download,
      iconType: 'badge',
      label: 'Retrieve from S3',
      feature: FeatureId.S3_RESTORE,
      disabled: () => isFIPSMode,
      tooltip: () =>
        isFIPSMode ? 'FIPS mode restricts access to S3 restore' : '',
    },
  ] as const;
}

// Keep the original options for backward compatibility
export const restoreOptions = createRestoreOptions();
